import { render, staticRenderFns } from "./SetProfile.vue?vue&type=template&id=3583d70e&scoped=true&"
import script from "./SetProfile.vue?vue&type=script&lang=js&"
export * from "./SetProfile.vue?vue&type=script&lang=js&"
import style0 from "./SetProfile.vue?vue&type=style&index=0&id=3583d70e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583d70e",
  null
  
)

export default component.exports